import { footerHandlers } from "./footerHandlers";
import { headerHandlers } from "./headerHandlers";
import { metaHandler } from "./metaHandler";

export const handlers = [...footerHandlers, ...headerHandlers, ...metaHandler];
